import { Variant } from '../../types/product';
import formatMoney from '../../utils/formatMoney';

const updateVariantPrice = (variantsData: Variant[], variantId: number): void => {
  const priceEl = document.querySelector<HTMLSpanElement>('[data-variant-price]');
  const comparePriceEl = document.querySelector<HTMLSpanElement>('[data-variant-compare-price]');
  if (!priceEl) return;

  const variant = variantsData.find((variant: Variant): boolean => variant.id === variantId);
  if (!variant) return;

  // Main price
  priceEl.textContent = formatMoney(variant.price);

  // Compare at price
  if (comparePriceEl) {
    if (variant.compare_at_price != null && variant.compare_at_price > variant.price) {
      comparePriceEl.textContent = formatMoney(variant.compare_at_price);
      comparePriceEl.classList.remove('hidden');
    } else {
      comparePriceEl.classList.add('hidden');
    }
  }
};

export default updateVariantPrice;
